import React, { useEffect, useRef, useState } from "react";
import { IoIosSearch, IoIosCloseCircle } from "react-icons/io";
import Table from "../Table/Table";
import { SortTable } from "../Table/SortTable";
import { SummaryColumns, SummaryColumnHeaders, AllPossibleColumns, HeaderToFieldMap } from '../../SiteSummary/constants';
import { SortTableMobile } from "../Table/SortTableMobile";
import MultiSelectDropdown from "../MultiSelectDropdown/MultiSelectDropDown";
import LoaderOverlay from "../Loader/LoaderOverlay";
import ActionPanel from "./ActionPanel";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomizeTable from "../CustomizeTable/index";
import { FaTableColumns, FaDownload } from "react-icons/fa6";
import DashboardCharts from "./DashboardCharts";
import DashboardChartsDrawer from "./DashboardChartsDrawer";
import { useMemo } from 'react';

import { VscPieChart } from "react-icons/vsc";
import { useContext } from "react";
import { WellsContext } from "../../../contexts/WellsContext";

interface SearchProps {
  tableData: any[];
  setSelectedNode: React.Dispatch<React.SetStateAction<{
    id: string;
    label: string;
  }>>;
  handleLogout: () => void;
  setWellData: React.Dispatch<React.SetStateAction<any[]>>;
  pageSize: number;
  setPageSize: React.Dispatch<React.SetStateAction<number>>;
  pageSelected: string;
  setPageSelected: React.Dispatch<React.SetStateAction<string>>;
  intialHeaders: any[];
  intialColumns: any[];
  dashboardData?: any[]; // NEW Add dashboard data prop
}

const SearchBar: React.FC<SearchProps> = ({ tableData, intialHeaders, intialColumns, setSelectedNode, handleLogout, setWellData, pageSize, setPageSize, pageSelected, setPageSelected, dashboardData }) => {
  const [page, setPage] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [filterData, setFilterData] = useState<any[]>(tableData);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 620);
  const [selectedValues, setSelectedValues] = useState<string[]>([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [hasChangedValue, sethasChangedValue] = useState(false);
  const [customerOptions, setCustomerOptions] = useState([]);
  const previousSelectedValuesRef = useRef<string[]>([]);
  const [isDropDownLoading, setIsDropDownLoading] = useState(false);
  const isAdmin = localStorage.getItem("jwtIsGroupAdmin") === "false" ? false : true;
  const isReadOnly = localStorage.getItem("jwtUserReadOnly") === "false" ? false : true;
  const isValveControlUser = localStorage.getItem("jwtIsValveControlUser") === "false" ? false : true;
  const [isActionPanelOpen, setIsActionPanelOpen] = useState(false);
  const [chartsData, setChartsData] = useState<any[]>([]); //NEW
  const [activeChartFilter, setActiveChartFilter] = useState<string | null>(null); // NEW: Track active filter

  // CustomizeTable states
  const [isTableColumnDrawer, setIsTableColumnDrawer] = useState(false);
  const [searchColumns, setSearchColumns] = useState("");
  const [duplicateDeviceOverviewColumns, setDuplicateDeviceOverviewColumns] = useState([]);
  const [dynamicColumnsAll, setDynamicColumnsAll] = useState([]);

  // Add new state for filtered columns and headers
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [filteredColumnHeaders, setFilteredColumnHeaders] = useState([]);

  // NEW: Dashboard Charts states for mobile
  const [isDashboardChartsDrawer, setIsDashboardChartsDrawer] = useState(false);

  const [isModalCLicked, setIsModalClicked] = useState(false)
  const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;

  const { setWellsData } = useContext(WellsContext);

  const updateAllWellStates = (wells: any[]) => {

    const safeWells = wells || [];

    setWellData(safeWells);
    setFilterData(safeWells);

    // Sync global wells context
    setWellsData(safeWells);
  };

  // Function to get browser timezone
  function getBrowserTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  // NEW: Dashboard Charts handlers for mobile
  const handleDashboardChartsToggle = () => {
    setIsDashboardChartsDrawer(true);
  };

  const handleCancelDashboardCharts = () => {
    setIsDashboardChartsDrawer(false);
  };


  const memoizedChartsData = useMemo(() => {
    return Array.isArray(chartsData) ? chartsData : [];
  }, [chartsData]);

  const handleSelectionChange = (selectedValues: string[], hasChanged: boolean) => {
    setSelectedValues(selectedValues);
    sethasChangedValue(hasChanged);
    localStorage.setItem("selectedCustomers", JSON.stringify(selectedValues));
  };

  // CustomizeTable handlers
  const handleCustomizeTableToggle = () => {
    setSearchColumns("")
    setIsTableColumnDrawer(true);
    fetchUserPreferences();
  };

  const handleCancelTableColumn = () => {
    setIsTableColumnDrawer(false);
  };

  const handleSearchColumns = (value: string) => {
    setSearchColumns(value);
  };

  const handleCheckboxChange = (isChecked: boolean, displayIndex: number, key: string) => {
    // Prevent unchecking of Well and Company columns
    if (key === "wellName" || key === "Well") {
      return;
    }

    const updatedColumns = [...duplicateDeviceOverviewColumns];
    // Find the actual index in the original array by key instead of using displayIndex
    const actualIndex = updatedColumns.findIndex(col => col.key === key);

    if (actualIndex !== -1) {
      updatedColumns[actualIndex].isChecked = isChecked;
      setDuplicateDeviceOverviewColumns(updatedColumns);

      // Update filtered columns based on checked state
      //updateTableColumns(updatedColumns);
    }
  };

  const updateHeaders = (newHeaderOrder: any[], newHeaderDummyDataOrder: any[]) => {
    // Update the column orders
    setDuplicateDeviceOverviewColumns(newHeaderOrder);
    setDynamicColumnsAll(newHeaderDummyDataOrder);

    // Update table columns based on new order
    //updateTableColumns(newHeaderOrder);
  };

  const updateTableColumns = (columns: any[]) => {
    const checked = columns.filter(c => c.isChecked);
    const orderedKeys = checked.map(c => c.key);

    const resolvedCols = orderedKeys.map(k =>
      SummaryColumns.find((c: any) => {
        const ck = (typeof c === 'object' && (c.key || c.accessor)) || c;
        return ck === k;
      })
    ).filter(Boolean);

    const resolvedHeaders = orderedKeys.map(k =>
      SummaryColumnHeaders.find((h: any) => {
        const hk = (typeof h === 'object' && (h.key || h.accessor)) ||
          (typeof h === 'string' ? h : null);
        return hk === k;
      })
    ).filter(Boolean);

    // Safety net: if nothing resolves, keep current columns (avoid blank table)
    if (resolvedCols.length === 0 || resolvedHeaders.length === 0) {
      console.warn("No matching columns found for saved order; keeping prior columns.");
      return; // do not clobber current state with empties
    }

    // setFilteredColumns(resolvedCols);
    // setFilteredColumnHeaders(resolvedHeaders);
  };


  const updateColumnSelectionPreference = async (columnPreferences: any, resetColumnSelection: boolean = false, isSelectAllChecked: boolean = false) => {
    const updatePreferenceApiUrl = `${baseUrl}/UserPreference/UpdateColumnSelectionPreference?resetColumnSelection=${resetColumnSelection}`;

    try {
      const headers = {
        'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
        'Content-Type': 'application/json'
      };

      // Determine allColumnsSelected based on:
      // 1. If isSelectAllChecked is explicitly passed as true
      // 2. OR if all non-disabled columns are checked
      let allColumnsSelected = false;

      if (isSelectAllChecked) {
        allColumnsSelected = true;
      } else {
        // Check if all non-disabled columns are checked
        const nonDisabledColumns = columnPreferences.columnSelections.filter((col: any) => !col.isDisabled);
        const checkedColumns = nonDisabledColumns.filter((col: any) => col.isChecked);
        allColumnsSelected = nonDisabledColumns.length > 0 && checkedColumns.length === nonDisabledColumns.length;
      }

      const requestBody = {
        allColumnsSelected: allColumnsSelected,
        columnSelections: columnPreferences.columnSelections.map((col: any, index: number) => ({
          columnName: col.title, // Use title as columnName for API
          order: index + 1, // Ensure sequential ordering starting from 1
          checked: col.isChecked
        }))
      };

      const response = await fetch(updatePreferenceApiUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(requestBody)
      });

      if (response.status === 401) {
        handleLogout();
        return false;
      }

      if (!response.ok) {
        throw new Error(`Failed to update column preferences: ${response.statusText}`);
      }

      const responseData = await response.json();
      return true;

    } catch (error) {
      console.error('Error updating column preferences:', error);
      throw error;
    }
  };

  // Update handleSaveTableColumn to pass the selectAll state
  const handleSaveTableColumn = async (isSelectAllActive: boolean = false) => {
    try {
      // Prepare column preferences in the format expected by the API
      const columnPreferences = {
        columnSelections: duplicateDeviceOverviewColumns,
        timestamp: new Date().toISOString()
      };

      // Call updateColumnSelectionPreference with selectAll state
      const success = await updateColumnSelectionPreference(columnPreferences, false, isSelectAllActive);

      if (success) {
        // Update the table columns only after successful API call
        updateTableColumns(duplicateDeviceOverviewColumns);

        // Save to localStorage after successful API call
        localStorage.setItem("tableColumnPreferences", JSON.stringify(columnPreferences));

        toast.success('Column preferences saved successfully');
        setIsTableColumnDrawer(false);
        setIsModalClicked(true)
      } else {
        toast.error('Failed to save column preferences to server');
      }

    } catch (error) {
      console.error('Error saving column preferences:', error);
      toast.error('Failed to save column preferences');
    }
  };
  const loadColumnPreferences = () => {
    // Try to load from localStorage first
    const savedPreferences = localStorage.getItem("tableColumnPreferences");

    if (savedPreferences) {
      try {
        const preferences = JSON.parse(savedPreferences);
        return preferences.columnOrder;
      } catch (error) {
        console.error('Error parsing saved preferences:', error);
      }
    }

    return null;
  };

  // Fetch user preferences
  const fetchUserPreferences = async () => {
    const userPreferenceApiUrl = `${baseUrl}/UserPreference/GetUserPreference`;

    try {
      const headers = {
        'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
        'Content-Type': 'application/json'
      };

      const response = await fetch(userPreferenceApiUrl, { headers });

      if (response.status === 401) {
        handleLogout();
        return;
      }

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      let columns;

      // Check if we have the new API response structure
      if (data && data.userPreference && data.userPreference.columnSelections) {
        const { columnSelections, allColumnsSelected } = data.userPreference;

        // Sort columns by order
        const sortedColumns = columnSelections.sort((a: any, b: any) => a.order - b.order);

        // Map API response to our column structure
        columns = sortedColumns.map((apiColumn: any) => {
          // Find matching column from SummaryColumnHeaders (which are just strings)
          const matchingHeader = SummaryColumnHeaders.find((header: string) => {
            return header.toLowerCase() === apiColumn.columnName.toLowerCase();
          });

          // Use the matching header as key, or fallback to API column name
          const columnKey = matchingHeader || apiColumn.columnName;

          // Check if this is a protected column
          const isProtectedColumn = columnKey === "Well" ||
            apiColumn.columnName === "Well";

          return {
            key: columnKey,
            title: apiColumn.columnName,
            isChecked: allColumnsSelected ? true : apiColumn.checked,
            isDisabled: isProtectedColumn,
            order: apiColumn.order
          };
        });
      } else {
        // Fallback: Try to load from localStorage first
        const savedColumnOrder = loadColumnPreferences();

        if (savedColumnOrder && Array.isArray(savedColumnOrder)) {
          columns = savedColumnOrder;
        } else {
          // Create default column structure from SummaryColumnHeaders (array of strings)
          columns = SummaryColumnHeaders.map((header: string, index: number) => {
            const isProtectedColumn = header === "Well";
            return {
              key: header,
              title: header,
              isChecked: true,
              isDisabled: isProtectedColumn,
              order: index + 1
            };
          });
        }
      }

      // Ensure Well and Company are always checked and at the top
      const wellColumn = columns.find((col: any) => col.title === "Well" || col.key === "Well");
      // const companyColumn = columns.find((col: any) => col.title === "Company" || col.key === "Company");

      if (wellColumn) {
        wellColumn.isChecked = true;
        wellColumn.isDisabled = true;
      }

      // if (companyColumn) {
      //   companyColumn.isChecked = true;
      //   companyColumn.isDisabled = true;
      // }

      setDynamicColumnsAll(columns);
      setDuplicateDeviceOverviewColumns(columns);

    } catch (error) {
      console.error('Error fetching user preferences:', error);
      toast.error('Failed to load user preferences');
    }
  };

  const handleChartSliceClick = async (chartTitle: string, category: string, filter: string, isActive: boolean) => {

    // Get the current selected customers and node info
    const selectedCustomers = JSON.parse(localStorage.getItem("selectedCustomers") || "[]");
    const storedNode = localStorage.getItem("selectedNode");
    const selectedNode = storedNode ? JSON.parse(storedNode) : null;

    if (isActive && filter) {
      try {
        // Create query parameters for GET request
        const queryParams = new URLSearchParams({
          timeZoneId: getBrowserTimeZone(),
          nodeId: selectedNode?.id === "#" || selectedNode?.id === undefined ? "null" : (selectedNode?.id || "null"),
          customerId: selectedCustomers.length > 0 ? selectedCustomers.join(',') : "null",
          chartFilter: filter
        });

        const apiUrl = `${baseUrl}/Wells/GetALLWells?${queryParams.toString()}`;

        const headers = {
          Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
          "Content-Type": "application/json",
        };

        // Use GET method without body
        const response = await fetch(apiUrl, {
          method: "GET",
          headers
        });

        if (response.status === 401) {
          handleLogout();
          return;
        }

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const filteredWells = await response.json();

        // Update your table data state
        const wells = filteredWells[0]?.wells || [];
        updateAllWellStates(wells);
        setActiveChartFilter(`${chartTitle}: ${category}`);
      } catch (error) {
        console.error('Error fetching filtered wells:', error);
      }
    } else {
      // If slice is deactivated, reset to show all wells using GET method
      try {
        const queryParams = new URLSearchParams({
          timeZoneId: getBrowserTimeZone(),
          nodeId: selectedNode?.id === "#" || selectedNode?.id === undefined ? "null" : (selectedNode?.id || "null"),
          customerId: selectedCustomers.length > 0 ? selectedCustomers.join(',') : "null"
        });

        const apiUrl = `${baseUrl}/Wells/GetALLWells?${queryParams.toString()}`;

        const headers = {
          Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
          "Content-Type": "application/json",
        };

        // Use GET method without body
        const response = await fetch(apiUrl, {
          method: "GET",
          headers
        });

        if (response.status === 401) {
          handleLogout();
          return;
        }
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const allWells = await response.json();
        updateAllWellStates(allWells[0]?.wells || []);
        setActiveChartFilter(null);
      } catch (error) {
        console.error('Error fetching all wells:', error);
      }
    }
  };

  // Initialize filtered columns on component mount - defaut headers and columns - 1 run
  useEffect(() => {
    setFilteredColumns(intialColumns);
    setFilteredColumnHeaders(intialHeaders);
  }, []);

  // Fetch customer options and store them in sessionStorage to cache the data
  useEffect(() => {
    const apiUrl = `${baseUrl}/Customer/GetAllCustomers`;

    if (isDropdownOpen) {
      // Check if data is cached
      const cachedCustomerOptions = sessionStorage.getItem("customerOptions");

      if (cachedCustomerOptions) {
        setCustomerOptions(JSON.parse(cachedCustomerOptions));
        setIsDropDownLoading(false);
        return;
      }

      setIsDropDownLoading(true);
      const fetchData = async () => {
        const headers = {
          'Authorization': `Bearer ${localStorage.getItem("jwtAccessToken")}`,
          'Content-Type': 'application/json'
        };

        try {
          const response = await fetch(apiUrl, { headers });
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          setCustomerOptions(data);
          sessionStorage.setItem("customerOptions", JSON.stringify(data));
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setIsDropDownLoading(false);
        }
      };

      fetchData();
    }
  }, [isDropdownOpen]);

  useEffect(() => {
    const selectedCustomers = JSON.parse(localStorage.getItem("selectedCustomers") || "[]");
    const queryParamsForFirstLoad = {
      timeZoneId: getBrowserTimeZone(),
      customerId: selectedCustomers || [],
    };

    // Retrieve selectedNode from localStorage
    const storedNode = localStorage.getItem("selectedNode");
    const selectedNode = storedNode ? JSON.parse(storedNode) : null;

    const apiUrlForFirstLoad = `${baseUrl}/Wells/GetWells`;
    const dashboardQueryParamsForFirstLoad = new URLSearchParams({
      timeZoneId: getBrowserTimeZone(),
      //nodeId: selectedNode?.id === "#" || selectedNode?.id === undefined ? null : selectedNode?.id,
      nodeId: 'null',
      customerId: selectedCustomers.length > 0 ? selectedCustomers.join(',') : 'null'
    });
    const dashboardApiUrlForFirstLoad = `${baseUrl}/Wells/GetWellsDashboard?${dashboardQueryParamsForFirstLoad.toString()}`;

    if (!isDropdownOpen && !hasChangedValue && selectedCustomers?.length > 0) {
      setSelectedNode(null);
      localStorage.removeItem("selectedNode");
      setTableLoading(true);

      const fetchData = async () => {
        try {
          const [wellsResponse, dashboardResponse] = await Promise.all([
            fetch(apiUrlForFirstLoad, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(queryParamsForFirstLoad),
            }),
            fetch(dashboardApiUrlForFirstLoad, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                "Content-Type": "application/json",
              }
            })
          ]);

          if (wellsResponse.status === 401 || dashboardResponse.status === 401) {
            handleLogout();
            return;
          }

          if (!wellsResponse.ok || !dashboardResponse.ok) {
            throw new Error("Network response was not ok");
          }

          const data = await wellsResponse.json();
          const dashboardData = await dashboardResponse.json();

          const wells = data[0]?.wells || [];
          updateAllWellStates(wells);
          setChartsData(dashboardData?.charts || []);
          sessionStorage.setItem("wellsData", JSON.stringify(data[0]?.wells));
          setFilteredColumnHeaders(data[0]?.columns);

          const filteredColumns = data[0]?.columns
            .map((header) => HeaderToFieldMap[header]);

          setFilteredColumns(filteredColumns);
          setIsModalClicked(false);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setTableLoading(false);
        }
      };

      fetchData();
    }
  }, [isDropdownOpen, hasChangedValue]);


  // ✅ CORRECT - Only run when both conditions are met
  useEffect(() => {
    const queryParams = {
      timeZoneId: getBrowserTimeZone(),
      customerId: selectedValues || []
    };

    const apiUrlForCustomerWells = `${baseUrl}/Wells/GetWells`;

    // Get selectedNode from localStorage - SAME AS SITESUMMARY
    const storedNode = localStorage.getItem("selectedNode");
    const selectedNode = storedNode ? JSON.parse(storedNode) : null;

    // Change dashboard API to use GET with query parameters
    const dashboardQueryParams = new URLSearchParams({
      timeZoneId: getBrowserTimeZone(),
      nodeId: 'null',
      customerId: selectedValues.length > 0 ? selectedValues.join(',') : 'null'
    });
    const dashboardApiUrlForCustomerWells = `${baseUrl}/Wells/GetWellsDashboard?${dashboardQueryParams.toString()}`;

    // ✅ Only run when dropdown is closed AND there was a change
    if (!isDropdownOpen && hasChangedValue) {
      setSelectedNode(null)
      localStorage.removeItem("selectedNode");
      setTableLoading(true)
      const fetchData = async () => {
        try {
          // Fetch both wells data and dashboard data
          const [wellsResponse, dashboardResponse] = await Promise.all([
            fetch(apiUrlForCustomerWells, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(queryParams),
            }),
            // Change to GET request
            fetch(dashboardApiUrlForCustomerWells, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                "Content-Type": "application/json",
              }
            })
          ]);

          if (wellsResponse.status === 401 || dashboardResponse.status === 401) {
            handleLogout();
            return;
          }

          if (!wellsResponse.ok || !dashboardResponse.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await wellsResponse.json();
          const dashboardData = await dashboardResponse.json();

          const wells = data[0]?.wells || [];
          updateAllWellStates(wells);
          setChartsData(dashboardData?.charts || []); // Set charts data
          setFilteredColumnHeaders(data[0]?.columns)

          const filteredColumns = data[0]?.columns
            .map((header) => HeaderToFieldMap[header])

          setFilteredColumns(filteredColumns)
          setIsModalClicked(false)

          // ✅ Reset the hasChangedValue flag after successful fetch
          sethasChangedValue(false);
        } catch (error) {
          //console.error("Error fetching data:", error);
        } finally {
          setTableLoading(false);
        }
      };

      fetchData();
    } else {
      //console.log("Conditions not met - isDropdownOpen:", isDropdownOpen, "hasChangedValue:", hasChangedValue);
    }
  }, [isDropdownOpen, hasChangedValue, selectedValues]) // Added selectedValues to dependencies

  useEffect(() => {
    const queryParams = {
      timeZoneId: getBrowserTimeZone(),
      customerId: selectedValues || []
    };
    const selectedCustomers = JSON.parse(localStorage.getItem("selectedCustomers") || "[]");
    const storedNode = localStorage.getItem("selectedNode");
    const selectedNode = storedNode ? JSON.parse(storedNode) : null;

    const queryParamsSelectedNode = {
      timeZoneId: getBrowserTimeZone(),
      //nodeId: selectedNode?.id === "#" || selectedNode?.id === undefined ? null : selectedNode?.id,
      nodeId: 'null',
      customerId: selectedCustomers?.length > 0 ? selectedCustomers.join(',') : 'null'
    };

    const apiUrlForCustomerWells = `${baseUrl}/Wells/GetWells`;
    if (isModalCLicked && selectedCustomers?.length > 0) {
      setTableLoading(true);

      // Build dashboard query params for customer scenario
      const dashboardQueryParams = new URLSearchParams({
        timeZoneId: getBrowserTimeZone(),
        //nodeId: selectedNode?.id === "#" || selectedNode?.id === undefined ? null : selectedNode?.id,
        customerId: selectedCustomers?.length > 0 ? selectedCustomers.join(',') : 'null',
        nodeId: null
      });
      const dashboardApiUrl = `${baseUrl}/Wells/GetWellsDashboard?${dashboardQueryParams.toString()}`;
      const fetchData = async () => {
        try {
          // Fetch both wells and dashboard data
          const [wellsResponse, dashboardResponse] = await Promise.all([
            fetch(apiUrlForCustomerWells, {
              method: "POST",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(queryParams),
            }),
            fetch(dashboardApiUrl, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
                "Content-Type": "application/json",
              }
            })
          ]);

          if (wellsResponse.status === 401 || dashboardResponse.status === 401) {
            handleLogout();
          }

          if (!wellsResponse.ok || !dashboardResponse.ok) {
            throw new Error("Network response was not ok");
          }
          const data = await wellsResponse.json();
          const dashboardData = await dashboardResponse.json();
          const wells = data[0]?.wells || [];
          updateAllWellStates(wells);
          setChartsData(dashboardData?.charts || []); // Set charts data
          setFilteredColumnHeaders(data[0]?.columns)

          const filteredColumns = data[0]?.columns
            .map((header) => HeaderToFieldMap[header])

          setFilteredColumns(filteredColumns)
          setIsModalClicked(false)
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setTableLoading(false);
        }
      };

      fetchData();
    }
    else if (isModalCLicked) {
      const apiUrl = `${baseUrl}/Wells/GetALLWells?${new URLSearchParams(queryParamsSelectedNode).toString()}`;
      const dashboardApiUrl = `${baseUrl}/Wells/GetWellsDashboard?${new URLSearchParams(queryParamsSelectedNode).toString()}`;
      const userPrefrenceApiUrl = `${baseUrl}/UserPreference/GetUserPreference`;
      setTableLoading(true)
      const fetchData = async () => {
        setTableLoading(true);
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
          "Content-Type": "application/json",
        };
        try {
          // Fetch wells, dashboard, and user preferences
          const [wellsResponse, dashboardResponse, userPrefResponse] = await Promise.all([
            fetch(apiUrl, { headers }),
            fetch(dashboardApiUrl, { headers }),
            fetch(userPrefrenceApiUrl, { headers })
          ]);

          if (wellsResponse.status === 401 || dashboardResponse.status === 401 || userPrefResponse.status === 401) {
            handleLogout();
          }
          if (!wellsResponse.ok || !dashboardResponse.ok || !userPrefResponse.ok) {
            throw new Error("Network response was not ok");
          }

          const data = await wellsResponse.json();
          const dashboardData = await dashboardResponse.json();
          const userPrefernceData = await userPrefResponse.json();

          const storedItemsPerPage = localStorage.getItem("itemsPerPage");

          if (!storedItemsPerPage || storedItemsPerPage === null || storedItemsPerPage === "undefined") {
            if (userPrefernceData?.userPreference?.itemsPerPage?.toString()?.toLocaleLowerCase() === "all") {
              setPageSize(data[0]?.wells?.length + 1)
            } else {
              setPageSize(parseInt(userPrefernceData?.userPreference?.itemsPerPage?.toString()))
            }
            setPageSelected(userPrefernceData?.userPreference?.itemsPerPage?.toString())
            localStorage.setItem("itemsPerPage", userPrefernceData?.userPreference?.itemsPerPage);
          }
          const wells = data[0]?.wells || [];
          updateAllWellStates(wells);
          setChartsData(dashboardData?.charts || []); // Set charts data
          setFilteredColumnHeaders(data[0]?.columns)

          const filteredColumns = data[0]?.columns
            .map((header) => HeaderToFieldMap[header])

          setFilteredColumns(filteredColumns)
          setIsModalClicked(false)
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setTableLoading(false);
        }
      };

      fetchData();


    }
    setIsModalClicked(false)
  }, [isModalCLicked])

  // Handle resizing of the window to check for mobile view
  useEffect(() => {
    let timeoutId;

    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setIsMobile(window.innerWidth < 620);
      }, 100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);


  useEffect(() => {
    if (dashboardData && dashboardData.length > 0) {
      setChartsData(dashboardData);
    }
  }, [dashboardData]); //NEW

  const handleValueChange = (searchTerm: string) => {
    setSearchValue(searchTerm);
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const filteredData = tableData.filter((item) => {
      return Object.values(item).some((value) => {
        if (typeof value === 'string') {
          return value.toLowerCase().includes(lowerCaseSearchTerm);
        }
        return false;
      });
    });
    setPage(1);
    setFilterData(filteredData);
  };

  const removeSearchText = () => {
    setSearchValue("");
    setFilterData(tableData);
  };

  const handleActionsPanelToggle = () => {
    setIsActionPanelOpen(!isActionPanelOpen);
  };

  const handleActionsPanelClose = () => {
    setIsActionPanelOpen(false);
  };


  const handleDefaultSet = async () => {
    try {

      const defaultColumns = AllPossibleColumns.map((columnName: string, index: number) => {
        // Check if this column is in SummaryColumnHeaders (should be checked by default)
        const isInSummaryHeaders = SummaryColumnHeaders.includes(columnName);
        const isProtectedColumn = columnName === "Well";

        return {
          key: columnName,
          title: columnName,
          isChecked: isInSummaryHeaders, // Only check columns that are in SummaryColumnHeaders
          isDisabled: isProtectedColumn,
          order: index + 1
        };
      });

      // Update drawer state
      setDuplicateDeviceOverviewColumns(defaultColumns);
      setDynamicColumnsAll(defaultColumns);

      // Send reset request to API
      const columnPreferences = {
        columnSelections: defaultColumns,
        timestamp: new Date().toISOString()
      };

      const success = await updateColumnSelectionPreference(columnPreferences, true); // resetColumnSelection = true

      if (success) {
        // Update table columns with only the checked (SummaryColumnHeaders) columns
        const checkedColumns = defaultColumns.filter(col => col.isChecked);
        updateTableColumns(checkedColumns);

        // Update localStorage
        localStorage.setItem("tableColumnPreferences", JSON.stringify(columnPreferences));

        toast.success('Column preferences reset to default');
        setIsModalClicked(true)

        // Close the drawer immediately after successful reset
        setIsTableColumnDrawer(false);
      } else {
        toast.error('Failed to reset column preferences');
      }

    } catch (error) {
      console.error('Error resetting column preferences:', error);
      toast.error('Failed to reset column preferences');
    }
  };

  const handleDownloadCSV = () => {
    try {
      if (!filterData || filterData.length === 0) {
        toast.error('No data available to download');
        return;
      }

      // Get the current visible columns based on filteredColumnHeaders
      const headers = filteredColumnHeaders || [];
      const columns = filteredColumns || [];

      // Create CSV headers
      const csvHeaders = headers.join(',');

      // Create CSV rows
      const csvRows = filterData.map(row => {
        return columns.map(column => {
          const value = row[column] || '';
          // Escape commas and quotes in CSV values
          const escapedValue = String(row[column] ?? '').replace(/"/g, '""');
          return `"${escapedValue}"`;
        }).join(',');
      });

      // Combine headers and rows
      const csvContent = [csvHeaders, ...csvRows].join('\n');

      // Create filename with local date and browser time
      const now = new Date();
      const localDate = now.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/\//g, '-'); // Convert MM/DD/YYYY to MM-DD-YYYY

      const browserTime = now.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).replace(/:/g, '-'); // Convert HH:MM:SS to HH-MM-SS

      const filename = `Asset_Summary_${localDate}_${browserTime}.csv`;

      // Create and download the file
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success('CSV file downloaded successfully');
    } catch (error) {
      console.error('Error downloading CSV:', error);
      toast.error('Failed to download CSV file');
    }
  };

  return (
    <>

      <div>{/* Dashboard Charts */}
        {!isMobile && (
          <DashboardCharts
            // chartsData={chartsData} 
            //chartsData={chartsData && chartsData.length > 0 ? [chartsData[0]] : []}
            chartsData={memoizedChartsData}
            onSliceClick={handleChartSliceClick}
          />
        )}

      </div>

      <br></br>
      {/* Search Bar & Multi-Select Dropdown Container */}
      <div className="flex items-center max-w-full relative z-[10] gap-[8px] justify-between w-full">

        {/* Search Bar - For Non-Mobile Users */}
        {!isMobile && (

          <div
            className="grid items-center pl-[12px] pr-[8px] max-w-full shrink grow min-h-[32px] grid-cols-[auto_1fr] gap-[8px] min-w-[20px] rounded-[6px] border-darkcolor-400 bg-darkcolor-700 border-[1px] border-solid"
          >
            {/* Search Icon */}
            <div>
              <IoIosSearch className="inline-block select-none align-text-bottom overflow-visible" />
            </div>

            {/* Search Input */}
            <div className="relative flex items-center z-[2] h-full w-full" style={{ maxHeight: "unset" }}>
              <div className="absolute select-none whitespace-nowrap text-[14px] flex-1 w-full p-0 top-1/2 translate-y-1/2">
                <span className="relative inline-block whitespace-pre"></span>
              </div>
              <div className="w-full h-full">
                <div className={`absolute top-1 left-0 whitespace-pre ${searchValue ? "invisible" : "visible"}`}>
                  Filter by keyword
                </div>
                <input
                  onChange={(e) => handleValueChange(e.target.value)}
                  name="filter"
                  className="w-full text-white border-0 p-0 shadow-none flex relative resize-none outline-none bg-transparent caret-Darkmode-700 text-[14px] flex-1 h-full"
                  style={{ maxHeight: "unset" }}
                  value={searchValue}
                />
              </div>
              {/* Clear Search Button */}
              <div className="flex items-center relative right-[25px] z-4">
                <button className="text-white w-[28px]" style={{ padding: "unset" }} onClick={removeSearchText}>
                  {searchValue && (
                    <IoIosCloseCircle
                      size={20}
                      className="inline-block select-none align-text-bottom cursor-pointer bg-darkcolor-700"
                    />
                  )}
                </button>
              </div>
            </div>
          </div>
        )}

        {!isMobile && isAdmin && (
          <MultiSelectDropdown
            options={customerOptions}
            placeholder="Customers"
            onChange={handleSelectionChange}
            isOpen={isDropdownOpen}
            setIsOpen={setIsDropdownOpen}
            isDropDownLoading={isDropDownLoading}
            isMobile={isMobile}
          />
        )}

        {/* Desktop: MultiSelect for Admins, Actions for all except read-only */}
        {!isMobile && (
          <div className="relative min-h-[2px] flex ml-[0px] items-center gap-1">

            {(!isReadOnly || isValveControlUser) && (
              <button
                type="button"
                className="btn btn-primary"
                style={{ backgroundColor: "var(--Primary-Indigo-700, #005F7C)" }}
                onClick={handleActionsPanelToggle}
              >
                Actions
              </button>
            )}

            {/* Download CSV Button - Available for all users */}
            <button
              type="button"
              onClick={handleDownloadCSV}
              className="
                inline-flex items-center justify-center gap-1
                h-9 px-3 rounded-[10px] whitespace-nowrap leading-none
                border
                hover:text-primary-500 hover:border-primary-500
                focus:outline-none focus:ring-2 focus:ring-primary-700/40 
              "
              style={{
                backgroundColor: "transparent",
                borderColor: "rgba(255,255,255,0.36)"
              }}
            >

              <span className="text-[14px] font-medium">Export to CSV</span>
              <FaDownload size={14} />
            </button>

            {/* Columns button - Available for all users */}
            <button
              type="button"
              onClick={handleCustomizeTableToggle}
              className="
                inline-flex items-center justify-center gap-2
                h-9 px-3 rounded-[10px] whitespace-nowrap leading-none
                border text-neutral-25
                hover:text-primary-500 hover:border-primary-500
                focus:outline-none focus:ring-2 focus:ring-primary-700/40
              "
              style={{
                backgroundColor: "transparent",
                borderColor: "rgba(255,255,255,0.36)",
              }}
            >
              <span className="text-[14px] font-medium">Columns</span>
              <FaTableColumns size={14} />
            </button>
          </div>
        )}

        {/* Cancel Button for Non-Admins */}
        {!isAdmin && !isMobile && (
          <button
            onClick={removeSearchText}
            className="py-0 px-[8px] h-[28px] gap-[4px] text-[14px] rounded-[6px] border-Darkmode-300 border-[1px] border-solid bg-Darkmode-700 focus:outline-none text-white"
          >
            Cancel
          </button>
        )}

        {/* Mobile-Specific Layout (Separate Search & Dropdown) */}
        {isMobile && (
          <div className="w-full flex flex-col gap-2">
            {/* Search Bar for Mobile */}
            <div
              className="w-full grid items-center pl-[12px] pr-[8px] min-h-[32px] grid-cols-[auto_1fr] gap-[8px] min-w-[20px] rounded-[6px] border-darkcolor-400 bg-darkcolor-700 border-[1px] border-solid"
            >
              {/* Search Icon */}
              <div>
                <IoIosSearch className="inline-block select-none align-text-bottom overflow-visible" />
              </div>

              {/* Search Input */}
              <div className="relative flex items-center z-[2] h-full w-full" style={{ maxHeight: "unset" }}>
                <div className="absolute select-none whitespace-nowrap text-[14px] flex-1 w-full p-0 top-1/2 translate-y-1/2">
                  <span className="relative inline-block whitespace-pre"></span>
                </div>
                <div className="w-full h-full">
                  <div className={`absolute top-1 left-0 whitespace-pre ${searchValue ? "invisible" : "visible"}`}>
                    Filter by keyword
                  </div>
                  <input
                    onChange={(e) => handleValueChange(e.target.value)}
                    name="filter"
                    className="w-full text-white border-0 p-0 shadow-none flex relative resize-none outline-none bg-transparent caret-Darkmode-700 text-[14px] flex-1 h-full"
                    style={{ maxHeight: "unset" }}
                    value={searchValue}
                  />
                </div>
                {/* Clear Search Button */}
                <div className="flex items-center relative right-[25px] z-4">
                  <button className="text-white w-[28px]" style={{ padding: "unset" }} onClick={removeSearchText}>
                    {searchValue && (
                      <IoIosCloseCircle
                        size={20}
                        className="inline-block select-none align-text-bottom cursor-pointer bg-darkcolor-700"
                      />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Mobile: MultiSelect for Admins and Actions for all except read-only */}
            <div className="w-full flex flex-col gap-2">
              {isAdmin && (
                <MultiSelectDropdown
                  options={customerOptions}
                  placeholder="Customers"
                  onChange={handleSelectionChange}
                  isOpen={isDropdownOpen}
                  setIsOpen={setIsDropdownOpen}
                  isDropDownLoading={isDropDownLoading}
                  isMobile={isMobile}
                />
              )}

              {(!isReadOnly || isValveControlUser) && (
                <button
                  type="button"
                  className="btn btn-primary w-full"
                  style={{ backgroundColor: "var(--Primary-Indigo-700, #005F7C)" }}
                  onClick={handleActionsPanelToggle}
                >
                  Actions
                </button>
              )}

              {/* Download CSV and Columns buttons side by side */}
              <div className="w-full flex gap-2">
                {/* Download CSV Button */}
                <button
                  type="button"
                  onClick={handleDownloadCSV}
                  className="
              flex-1 inline-flex items-center justify-center gap-2
              h-9 px-3 rounded-[6px] 
              border text-neutral-25 
              hover:text-primary-500 hover:border-primary-500 
              focus:outline-none focus:ring-2 focus:ring-primary-700/40
              "
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "rgba(255,255,255,0.36)",
                  }}
                >
                  <FaDownload size={14} />
                  <span className="text-[14px] font-medium">Export to CSV</span>
                </button>

                {/* Columns Button */}
                <button
                  type="button"
                  onClick={handleCustomizeTableToggle}
                  className="
              flex-1 inline-flex items-center justify-center gap-2 
              h-9 px-3 rounded-[6px] 
              border text-neutral-25 
              hover:text-primary-500 hover:border-primary-500 
              focus:outline-none focus:ring-2 focus:ring-primary-700/40
              "
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "rgba(255,255,255,0.36)",
                  }}
                >
                  <span className="text-[14px] font-medium">Columns</span>
                  <FaTableColumns size={14} />
                </button>

                <button
                  type="button"
                  onClick={handleDashboardChartsToggle}
                  className="
              inline-flex items-center justify-center gap-2 
              h-9 px-3 rounded-[6px] 
              border text-neutral-25 
              hover:text-primary-500 hover:border-primary-500 
              focus:outline-none focus:ring-2 focus:ring-primary-700/40
              "
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "rgba(255,255,255,0.36)",
                  }}
                >
                  {/* <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M3 13h4v8H3v-8Zm7-6h4v14h-4V7Zm7-4h4v18h-4V3Z" />
              </svg> */}
                  <VscPieChart />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>



      {/* Mobile: Dashboard Charts Drawer only */}
      {isMobile && (
        <DashboardChartsDrawer
          isOpen={isDashboardChartsDrawer}
          onClose={handleCancelDashboardCharts}
          chartsData={chartsData}
          onSliceClick={handleChartSliceClick}
        />
      )}

      {/* Table - Ensures Dropdown Does Not Push It Down */}
      <div className="relative z-[0]">
        {tableLoading ? <LoaderOverlay /> : (
          isMobile ? (
            <SortTableMobile
              data={filterData}
              columns={filteredColumns}
              defaultSortColumn="wellName"
              defaultSortOrder="asc"
              columnHeaders={filteredColumnHeaders}
              pagniation={true}
              page={page}
              setPage={setPage}
              searchValue={searchValue}
              pageSize={pageSize}
              setPageSize={setPageSize}
              pageSelected={pageSelected}
              setPageSelected={setPageSelected}
            />
          ) : (
            <SortTable
              data={filterData}
              columns={filteredColumns}
              defaultSortColumn="wellName"
              defaultSortOrder="asc"
              columnHeaders={filteredColumnHeaders}
              pagniation={true}
              page={page}
              setPage={setPage}
              searchValue={searchValue}
              pageSize={pageSize}
              setPageSize={setPageSize}
              pageSelected={pageSelected}
              setPageSelected={setPageSelected}
            />
          )
        )}
      </div>

      {/* Action Panel */}
      <ActionPanel
        isOpen={isActionPanelOpen}
        onClose={handleActionsPanelClose}
        customerOptions={customerOptions}
        tableData={filterData}
      />

      {/* <DashboardChartsDrawer
        isOpen={isDashboardChartsDrawer}
        onClose={handleCancelDashboardCharts}
        chartsData={chartsData}
        onSliceClick={handleChartSliceClick}
      /> */}

      {/* CustomizeTable Drawer */}
      <CustomizeTable
        isOpen={isTableColumnDrawer}
        onClose={handleCancelTableColumn}
        title="Customize Table"
        searchValue={searchColumns}
        onSearchChange={handleSearchColumns}
        duplicateColumns={duplicateDeviceOverviewColumns.map((column: any) => ({
          ...column,
          isChecked: (column.key === "wellName" ||
            column.title === "Well") ? true : column.isChecked,
          isDisabled: column.key === "wellName" ||
            column.title === "Well"
        }))}
        handleCheckboxChange={handleCheckboxChange}
        updateHeaders={updateHeaders}
        handleSaveTableColumn={handleSaveTableColumn}
        dynamicColumnsAll={dynamicColumnsAll}
        handleDefaultSet={handleDefaultSet}
      />

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default SearchBar;
